module.exports = __webpack_public_path__ + "static/bg-fd8bcb2bb404039b2ddbd573c205201e.jpg";